import { MonthsObject } from "../GetMonths/GetMonths";

export const AscendingSort = (values: MonthsObject) => Object.values(values).sort((primary: any, secondary: any) => primary.order > secondary.order ? 1 : -1);

export const SortByYearAndMonthAscending = (data) => {
    return data.sort((a, b) => {
        if (a.calendarYear === b.calendarYear) {
            return a.calendarMonth - b.calendarMonth;
        }
        return a.calendarYear - b.calendarYear;
    });
}